import { socialPlatforms } from '@app/modules/social-export/domain/platforms';
import { contentAi } from '@mi-front/api-clients';
import { ContentContainer } from '../../components';
import { ContentSocialVersion } from './ContentSocialVersion';
import { UserArticleViewer } from './UserArticleViewer';

export function ContentWizard_SocialVersionsStep({ content }: { content: contentAi.ContentDto }) {
  return (
    <ContentContainer>
      <UserArticleViewer content={content} />
      {socialPlatforms.all().map((platform) => (
        <ContentSocialVersion key={platform.id} platform={platform} content={content} />
      ))}
    </ContentContainer>
  );
}
